import { DISPLAY_BOARD_TYPES } from './display-board-types';

export const DISPLAY_BOARD_ROUTES = {
  [DISPLAY_BOARD_TYPES.WORKFLOW]: 'workflow',
  [DISPLAY_BOARD_TYPES.FAMILY]: 'family',
  [DISPLAY_BOARD_TYPES.PATIENT]: 'patient',
  [DISPLAY_BOARD_TYPES.ASSETS_PAR_LEVEL]: 'assets-par-level',
};
